<template>
  <div>
    <a-drawer title="Shipping Template" :visible="dialogVisible" width="1000px" centered="true" @close="handleClose('ruleForm')" :destroyOnClose="true">
      <a-form-model layout="horizontal" ref="ruleForm" :model="ruleForm" :rules="rules" size="small" v-if="dialogVisible">
        <a-form-model-item label="Template Name" prop="name">
          <a-input v-model="ruleForm.name" class="withs" placeholder="Please enter template name" />
        </a-form-model-item>
        <a-form-model-item label="Billing Method" prop="type">
          <a-radio-group v-model="ruleForm.type" button-style="solid" @change="changeRadio(ruleForm.type)">
            <a-radio-button v-for="(item, index) in this.customDict.FreightTypeEnum" :value="item.type" :key="index">
              {{ translateDict(item.name) }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="Logistics Type" prop="logisticsType">
          <a-radio-group v-model="ruleForm.logisticsType" button-style="solid" >
            <a-radio-button v-for="(item, index) in this.customDict.LogisticsTypeEnum" :value="item.type" :key="index">
              {{ translateDict(item.name) }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="Delivery Area & Freight"  prop="region">
          <a-table :columns="columns1" :data-source="ruleForm.region" :pagination="false"
                   :rowKey="(record,index)=>{return index}" class="tempBox">
            <div slot="areaInfos" slot-scope="text, record">
              <div class="custorhand" @click="editCity(1,record)">
                <template v-if="record.iSselect">
                  <div class="text-left text-bold">Global</div>
                </template>
                <template v-else>
                  <span class="text-left" v-for="(item, index) in record.areaInfos" :key="index">
                    <!-- 如果省全选，则只展示省不展示市，如果省没有全选 市要展示 -->
                    <span v-if="item.cityNum == item.selectedNum" class="text-bold">{{ item.province + ',' }}</span>
                    <div v-else>
                      <span class="text-bold">{{ item.province }}</span>
                      <span>: {{ item.title }}</span>
                    </div>
                  </span>
                </template>
              </div>
            </div>
            <template slot="first" slot-scope="text, record">
              <a-form-model-item prop="first" class="margin-bottom-0">
                <a-input-number v-model="record.first" controls-position="right" :min="ruleForm.type === 1 ? 1 : 1" />
              </a-form-model-item>
            </template>
            <template slot="firstPrice" slot-scope="text, record">
              <a-form-model-item prop="firstPrice" class="margin-bottom-0">
                <a-input-number v-model="record.firstPrice" controls-position="right" :min="0" />
              </a-form-model-item>
            </template>
            <template slot="renewal" slot-scope="text, record" >
              <a-form-model-item prop="renewal" class="margin-bottom-0">
                <a-input-number v-model="record.renewal" controls-position="right"
                                :step-strictly="ruleForm.type === 1 ? true : false"
                                :min="ruleForm.type === 1 ? 1 : 1" />
              </a-form-model-item>
            </template>
            <template slot="renewalPrice" slot-scope="text, record">
              <a-form-model-item prop="renewalPrice" class="margin-bottom-0">
                <a-input-number v-model="record.renewalPrice" controls-position="right" :min="0" />
              </a-form-model-item>
            </template>
            <template slot="action" slot-scope="text, record">
              <a href="javascript:void(0)" @click="confirmEdit(ruleForm.region, record, 1)" style="color:red;">Delete</a>
            </template>
          </a-table>
        </a-form-model-item>
        <a-form-model-item>
          <a-button style="margin-right: 10px" type="primary" size="small" @click="addCity(1)" v-show="!isSelectAllregion">
            <a-icon type="plus" />
            Add Delivery Area
          </a-button>

        </a-form-model-item>
        <a-form-model-item prop="sort" label="Sort">
          <a-input v-model="ruleForm.sort" class="withs" placeholder="Please enter sort" />
        </a-form-model-item>
        <a-form-model-item prop="remark" label="Remark">
          <a-input type="textarea" v-model="ruleForm.remark" />
        </a-form-model-item>

      </a-form-model>
      <div class="foot-btn">
        <a-button @click="handleClose" class="margin-right-sm">Cancel</a-button>
        <a-button type="primary"
                  :loading="loading"
                  @click="onsubmit('ruleForm')">OK
        </a-button>
      </div>
    </a-drawer>
    <city ref="city" @selectCity="selectCity" :type="type" :id="curAddressId"
          :otherSelectedArr="otherSelectedArr"
          :selectArr="selectArr">
    </city>
  </div>
</template>

<script>
import * as logistics from '@/api/logistics'
import CustomDictTag from "@/components/DictCustomTag";
import city from './city.vue';
import { mapGetters } from 'vuex'
import { guid, resetForm } from '@/utils/ruoyi.js'

const defaultRole = {
  name: '',
  type: 1,
  shippingArea: null,
  logisticsType: 1,
  appoint: false,
  sort: 0,
  remark:null,
  region: [],
}
const kg = 'Weight (kg)'
const m = 'Volume (m³)'
const statusMap = [
  {
    title: 'First Item',
    title2: 'Additional Item',
    title3: 'Free Shipping Items'
  },
  {
    title: `First ${kg}`,
    title2: `Additional ${kg}`,
    title3: `Free Shipping ${kg}`
  },
  {
    title: `First ${m}`,
    title2: `Additional ${m}`,
    title3: `Free Shipping ${m}`
  }
]
export default {
  name: 'CreatTemplates',
  components: {
    CustomDictTag,
    city
  },
  data() {
    return {
      loading: false,
      rules: {
        name: [
          { required: true, message: 'Please enter template name', trigger: 'blur' }
        ],
        shippingArea: [
          { required: true, message: 'Please select shipping location', trigger: 'change' }
        ],
        logisticsType: [
          { required: true, message: 'Please select logistics type', trigger: 'change' }
        ],
        type: [
          { required: true, message: 'Please select billing method', trigger: 'change' }
        ],
        region: [
          { required: true, message: 'Please add delivery area', trigger: 'change' }
        ],
        number: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
        price: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
      },
      rules_region: {
        first: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
        firstPrice: [
          { required: true, message: 'Please enter freight', trigger: 'blur' }
        ],
        renewal: [
          { required: true, message: 'Please enter', trigger: 'blur' }
        ],
        renewalPrice: [
          { required: true, message: 'Please enter renewal fee', trigger: 'blur' }
        ],
      },
      nodeKey: 'city_id',
      props: {
        children: 'child',
        label: 'name',
        value: 'cityId',
        multiple: true
      },
      dialogVisible: false,
      ruleForm: Object.assign({}, defaultRole),
      listLoading: false,
      isSelectAllregion: false,
      isSelectAllfree: false,
      cityList: [],
      columns: {
        title: 'First Item',
        title2: 'Additional Item',
        title3: 'Free Shipping Items'
      },
      columns1: [
        {
          width: 260,
          dataIndex: 'areaInfos',
          title: 'Deliverable Area',
          scopedSlots: { customRender: 'areaInfos' }
        }, {
          dataIndex: 'first',
          title: 'First Item',
          scopedSlots: { customRender: 'first' },
          width: 130
        }, {
          dataIndex: 'firstPrice',
          title: 'Freight ($)',
          scopedSlots: { customRender: 'firstPrice' },
          width: 120
        }, {
          dataIndex: 'renewal',
          title: 'Additional Item',
          scopedSlots: { customRender: 'renewal' },
          width: 120
        }, {
          dataIndex: 'renewalPrice',
          title: 'Renewal Fee ($)',
          scopedSlots: { customRender: 'renewalPrice' },
          width: 120
        }, {
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          title: 'Operation',
          width: 80
        }
      ],
      customColumn: [
        {
          width: 460,
          dataIndex: 'areaInfos',
          title: 'Deliverable Area',
          scopedSlots: { customRender: 'areaInfos' }
        }, {
          dataIndex: 'customNum',
          title: 'Quantity',
          scopedSlots: { customRender: 'customNum' },
          width: 100
        }, {
          dataIndex: 'customList',
          title: 'Config',
          width: 200,
          scopedSlots: { customRender: 'customList' },
        }, {
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          title: 'Operation',
          width: 80
        }
      ],
      tempId: 0,
      type: 0, // 0添加 1编辑
      addressModal: false,
      indeterminate: true,
      checkAll: false,
      checkAllGroup: [],
      activeCity: -1,
      provinceAllGroup: [],
      index: -1,
      displayData: '',
      currentProvince: '',
      selectArr: [], // 传递选中的城市
      // noShippingArr: [], // 不包邮选择的城市数据
      // yesShippingArr: [], // 包邮选择的城市数据
      // noDeliveryArr: [], // 不送达选择的城市数据
      curAddressId: 0,
      otherSelectedArr: []
    }
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict','acityList'])
  },
  mounted() {
    this.ruleForm.appoint = true
  },

  methods: {
    /**
     * 清空文本框的值
     */
    clear() {
      this.tempId = ''
      this.isSelectAllfree = false
      this.isSelectAllregion = false
      this.loading = false

      // this.$refs.ruleForm.resetFields()
      defaultRole.region = []
      this.ruleForm = Object.assign({}, defaultRole)
    },
    // 将中文枚举名翻译为英文显示
    translateDict(name) {
      if (!name) return ''
      const map = {
        '快递': 'Express',
        '物流': 'Logistics',
        '按件数': 'By Quantity',
        '按重量': 'By Weight'
      }
      return map[name] || name
    },
    handleShow() {
      this.dialogVisible = true
    },
    handleClose(formName) {
      this.clear()
      this.dialogVisible = false
      this.loading = false
    },

    /**获取某个省下面的市的个数 */
    getAreaNum(cityId) {
      let num = 0
      this.acityList.forEach((item,index)=>{
        if(item.areaId == cityId) {
          num = item.children.length
        }
      })
      return num
    },

    /**
     * 获取运费模板详情
     * appoint true包邮 false不包邮
     */
    getInfo(options) {
      options && (this.tempId = options.id)
      this.ruleForm = Object.assign({}, defaultRole)
      // const loadingInstance = Loading.service({ fullscreen: true })
      // 根据id获取运费模板详情
      logistics.templateDetailApi({ id: this.tempId }).then(res => {
        if(res.success) {
          let regionList = res.data.regionList
          /**增加data字段，回显已经选择的城市 iSselect*/
          if(regionList.length) {
            regionList.forEach((item,index)=>{
              let selectedCityNum = 0

              if(!item.id) item.id = guid(8,10)
              item.data = []
              item.areaInfos.forEach((item1,index1)=>{
                let obj = {
                  "areaName": item1.province,
                  "areaId": item1.provinceId
                }
                item.data.push(obj)
              })
              selectedCityNum = item.areaInfos.length
              if (selectedCityNum >= this.acityList.length) {
                regionList.forEach((item,index)=>{
                  item.iSselect =true
                })
              }
            })
            this.setBtnShow(regionList, 'isSelectAllregion')
          }
          this.ruleForm = Object.assign(this.ruleForm, {
            name: res.data.name,
            type: res.data.type,
            shippingArea: res.data.shippingArea,
            logisticsType: res.data.logisticsType,
            appoint: res.data.appoint,
            sort: res.data.sort,
            remark: res.data.remark,
            region: regionList,
          })

          this.columns = Object.assign({}, statusMap[this.ruleForm.type - 1])
          console.log('ruleForm', this.ruleForm)
          this.changeRadio(res.data.type)
          this.dialogVisible = true
        }
      }).catch(res => {
        this.$message.error(res.message)
      })
    },
    /**
     * 切换计费方式
     */
    changeRadio(num) {
      // this.columns = Object.assign({}, statusMap[num - 1])
      if(num == 1) {
        this.columns1[1].title = 'First Item'
        this.columns1[3].title = 'Additional Item'
      } else if(num == 2) {
        this.columns1[1].title = 'First Weight (kg)'
        this.columns1[3].title = 'Additional Weight (kg)'
      } else if(num == 3) {
        this.columns1[1].title = 'First Volume (m³)'
        this.columns1[3].title = 'Additional Volume (m³)'
      }
      this.$forceUpdate()
    },
    /**
     * 切换指定包邮
     */
    changeDelivertype(e) {
      this.ruleForm.appoint = e.target.value
    },
    changType(type) {
      this.type = type
      this.ruleForm.type = type
    },


    /**添加配送区域
     * 显示选择城市弹窗
     */
    addCity(type) {
      this.selectArr = []
      this.type = type;
      /** 获取 已经选中的城市数组,要置灰,不可勾选 */
      this.otherSelectedArr = []
      if(type == 1) {
        this.ruleForm.region.forEach((item, index)=>{
          this.otherSelectedArr.push(...item.data)
        })
      }

      this.$refs.city.empty()
      this.$refs.city.addressModal = true;
    },
    /**
     * 编辑城市区域弹窗
     */
    editCity(type, record) {
      this.type = type;
      this.curAddressId = record.id
      this.selectArr = []
      this.selectArr = record.data
      /** 获取 除当前这条数据以外其他的选中的城市数组 */
      this.otherSelectedArr = []
      if(type == 1) {
        this.ruleForm.region.forEach((item, index)=>{
          if(item.id != record.id) {
            this.otherSelectedArr.push(...item.data)
          }
        })
      }

      this.$refs.city.empty()
      this.$refs.city.addressModal = true;
    },
    /**添加配送区域
     * 选择城市后处理数据
     */
    selectCity(obj) {
      window.console.log('选择城市后得到的城市数组 data', obj)
      let data = obj.selectList, type = obj.type, iSselect = obj.iSselect, editedIndex = -1

      if(obj.isEdit) {
        // 编辑
        if(obj.type == 1) {
          editedIndex = this.ruleForm.region.findIndex(item=>{return item.id == obj.id})
        }
      }

      let areaInfos = []
      data.forEach(item => {
        let aobj = {
          provinceId: item.areaId,
          province: item.areaName,
          title: '',
          cityIds: '',
        }
        areaInfos.push(aobj)
      })
      switch (type) {
        case 1:
          if(obj.isEdit) {
            // 编辑
            let flag = iSselect

            this.$set(this.ruleForm.region[editedIndex], 'areaInfos', areaInfos)
            this.$set(this.ruleForm.region[editedIndex], 'data', obj.selectList)
            this.$set(this.ruleForm.region[editedIndex], 'iSselect', flag)
          }else{
            // 新增
            this.ruleForm.region.push({
              id: guid(8,10),
              iSselect: iSselect,
              areaInfos: areaInfos,
              first: 1,
              firstPrice: 0,
              renewal: 1,
              renewalPrice: 0,
              data: obj.selectList
            });
          }
          console.log('this.ruleForm.region',this.ruleForm.region)
          /**控制添加配送区域按钮显示隐藏 */
          //this.setBtnShow(this.ruleForm.region,iSselect, 'isSelectAllregion')
          break;
        case 3:
          this.noDeliveryList.push({
            place: data,
            placeName: cityName,
          });
          this.noDeliveryArr = this.noDeliveryArr.concat(data);
          break;
      }
    },
    /**
     * 控制 添加城市按钮 显示隐藏
     */
    setBtnShow(arr, iSselect, fieldname) {
       iSselect ? this[fieldname] = true : this[fieldname] = false
    },
    /**
     * 删除所选城市
     */
    confirmEdit(areaArr, record, type) {
      let delIndex = areaArr.findIndex(item=>{return item.id == record.id})
      areaArr.splice(delIndex, 1)
      let str = ''
      type == 1 ? str = 'isSelectAllregion' : str = 'isSelectAllfree'
      //this.setBtnShow(areaArr,false, str)
    },

    onsubmit: (function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          // 删掉data字段，这个只作为前端使用，不需要给后端
          let obj = JSON.parse(JSON.stringify(this.ruleForm))
          obj.region.forEach((item,index)=>{
            delete item.data
          })
          const param = {
            appoint: this.ruleForm.appoint,
            name: this.ruleForm.name,
            sort: this.ruleForm.sort,
            type: this.ruleForm.type,
            shippingArea: this.ruleForm.shippingArea,
            logisticsType: this.ruleForm.logisticsType,
            remark: this.ruleForm.remark,
            // 配送区域及运费
            regionList: obj.region,

          }

          window.console.log('param this.ruleForm', param, this.ruleForm)
          // return
          if (this.tempId) {
            param.id = this.tempId
            console.log('编辑param',param)
            logistics.shippingUpdate(param).then(res => {
              console.log('res', res)
              if (res.success) {
                this.$message.success('Operation successful')
                this.handleClose()
                this.$nextTick(() => {
                  this.dialogVisible = false
                  this.ruleForm = {}
                })
                setTimeout(() => {
                  this.$emit('getList')
                }, 600)
              }else{
                this.$message.error(res.message);
              }
              this.loading = false;
            })
          } else {
            logistics.shippingSave(param).then(response => {
              console.log('res添加数据', response)
              if (response.success) {
                this.$message.success('Added successfully')
                setTimeout(() => {
                  this.$emit('getList')
                  this.handleClose()
                }, 600)
                this.$nextTick(() => {
                  this.dialogVisible = false
                  this.ruleForm = {}
                })
              } else {
                this.$message.error(response.message);
              }
              this.loading = false
            })
          }
        } else {
          return false
        }
      })
    })
  }
}
</script>

<style scoped lang="less">
.withs {
  width: 50%;
}

.noBox {
  ::v-deep.a-form-model-item__content {
    margin-left: 0 !important;
  }
}

.tempBox {
  ::v-deep.a-input-number--mini {
    width: 100px !important;
  }
}

.custorhand {
  cursor: pointer;
}

.margin-bottom-0 {
  margin-bottom: 0!important;
}
</style>